import * as React from 'react';
import { RefObject, useRef, useState } from 'react';

import { Color } from '../../../../enums';
import { useOnClickOutside } from '../../../../hooks';
import { MenuPositionData } from '../../../../interfaces';
import { UseState } from '../../../../types';
import { Icon } from '../../../icon/icon.component';

import { Container, DropdownMenu, DropdownMenuPosition, DropdownMenuPositionLabel, DropdownMenuPositionWrapper } from './iconButton.styled';
import { IconButtonProps } from './iconButton.types';

export const IconButton: React.FC<IconButtonProps> = (props: IconButtonProps): JSX.Element => {
  const { onClickAction, menuPositions = [], icon, color, dataTestId, className }: IconButtonProps = props;
  const [dropdownMenuVisible, setDropdownMenuVisible]: UseState<boolean> = useState<boolean>(false);
  const containerRef: RefObject<HTMLDivElement> = useRef(null);
  useOnClickOutside<HTMLDivElement>([containerRef], (): void => setDropdownMenuVisible(false));

  const action = (): void => {
    if (!menuPositions.length) {
      onClickAction();
    } else {
      setDropdownMenuVisible(!dropdownMenuVisible);
    }
  };

  return (
    <Container
      ref={containerRef}
      data-testid={dataTestId}
      onClick={action}
      className={className}
      $active={!!menuPositions.length && dropdownMenuVisible}
    >
      <Icon
        name={icon}
        size={24}
        color={dropdownMenuVisible ? Color.Black : color}
      />
      {!!menuPositions.length && (
        <DropdownMenu $visible={dropdownMenuVisible}>
          {menuPositions.map((position: MenuPositionData): JSX.Element => (
            <DropdownMenuPositionWrapper onClick={(): void => setDropdownMenuVisible(false)} key={position.label}>
              <DropdownMenuPosition {...position} key={position.label}>
                {position.icon && (
                  <Icon
                    name={position.icon}
                    size={24}
                    color={Color.Black}
                  />
                )}
                <DropdownMenuPositionLabel>{position.label}</DropdownMenuPositionLabel>
              </DropdownMenuPosition>
            </DropdownMenuPositionWrapper>
          ))}
        </DropdownMenu>
      )}
    </Container>
  );
};
